import { Actions } from '../enums/ActionEnums';
import { ActionType } from '../models/appContext';

export const productReducer = (state: string | null, action: ActionType): string | null => {
  switch (action.type) {
    case Actions.SetSelectedProduct:
      return action.payload.name;
    case Actions.ResetSelectedProduct:
      return null;
    default:
      return state;
  }
};
